.customize-layout-button > button {
    height: 31px;
}
